import React from "react";
import { useLocation } from "react-router-dom";
import NavigationNav from './layouts/nav.js';
import NavigationNavHome from './layouts/navHome.js';

function AppLayout({ children }) {
  const location = useLocation();
  const path = location.pathname;

 const ocultarBarra =
  path.startsWith("/inicio") ||
  path.startsWith("/facturas") ||
  path.startsWith("/configuracion");

const barra = path === "/"
  ? <NavigationNavHome />
  : ocultarBarra
  ? null
  : <NavigationNav />;

  return (
    <>
      {barra}
      {children}
    </>
  );
}

export default AppLayout;
